import React from 'react'; // import InfoImg from './infoImg';

import './index.less';

const ConfirmInfoTitle = props => {
  const {
    title,
    alt
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: "com-confirmInfoTitle"
  }, /*#__PURE__*/React.createElement("div", {
    className: "right"
  }, title));
};

export default ConfirmInfoTitle;